module.exports = __webpack_public_path__ + "img/logo-rryb.9c85fd7a.png";